import React from 'react';
import { ConnectionModel } from '../components/features/ecm/connection.model';

export const getNonInitialConnections = (
    selectedConnections: Map<number, ConnectionModel>
): ConnectionModel[] =>
    Array.from(selectedConnections.values())
        .filter((conn) => !conn.isInitial);

export const isAllNonInitialConnections = (
    selectedConnections: Map<number, ConnectionModel>
): boolean => {
    return Array.from(selectedConnections.values()).every(
        (connection) => !connection.isInitial
    );
};

export const isAllIneligibleSmart = (
    selectedConnections: Map<number, ConnectionModel>
): boolean => {
    return Array.from(selectedConnections.values()).every(
        (connection) => !connection.isSmartEligible
    );
};

export const deselectNonInitialConnections = (
    selectedConnections: Map<number, ConnectionModel>,
    setSelectedConnections?: React.Dispatch<React.SetStateAction<Map<number, ConnectionModel>>>
) => {
    if (setSelectedConnections) {
        const newSelectedConnections = new Map(
            Array.from(selectedConnections.entries()).filter(
                ([, connection]) => connection.isInitial
            )
        );
        setSelectedConnections(newSelectedConnections);
    }
};

export const formatConnectionCount = (count: number, withVerb = false) => {
    const base = `${count} connection${count === 1 ? '' : 's'}`;
    if (withVerb) {
        return `${base} ${count === 1 ? 'is' : 'are'}`;
    }
    return base;
};
